import type { Theme, TRuleWithTheme } from '@/styles/theme';

export type HeadingVariant = 'h1' | 'h2' | 'h3';

const VARIANT_TOKEN = {
    h1: 'Headline1',
    h2: 'Headline2',
    h3: 'Headline3',
} as const satisfies Record<HeadingVariant, keyof Theme['typography']>;

export const container: TRuleWithTheme<{
    variant: HeadingVariant;
    color: keyof Theme['colors'];
}> = ({ theme, variant, color }) => ({
    ...theme.typography[VARIANT_TOKEN[variant]],
    color: theme.colors[color] || theme.colors.black,

    marginBottom: 0,

    min768: {
        color: theme.colors[color] || theme.colors.blue,
    },
});
